module.exports = __webpack_public_path__ + "img/lorent.10ef98e6.png";